var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:['button', _vm.className],attrs:{"href":"#!"},on:{"click":function($event){$event.preventDefault();return _vm.saveProduct.apply(null, arguments)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }